import i18n from '@/locales'
export default {
  system: {
    options: [
      { id: 'dashboard-system-default', name: i18n.t('dashboard.text_121') },
    ],
    'dashboard-system-default': [
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 0,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_130'),
          regionAccountType: 'region',
          usage_key: 'all.servers',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 20,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_136'),
          regionAccountType: 'region',
          usage_key: 'hosts',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 40,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_134'),
          regionAccountType: 'region',
          usage_key: 'baremetals',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 60,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_154'),
          regionAccountType: 'region',
          usage_key: 'all.buckets',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 0,
          y: 6,
        },
        params: {
          name: i18n.t('dashboard.text_122'),
          regionAccountType: 'region',
          usage_key: 'all.servers.cpu',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 20,
          y: 6,
        },
        params: {
          name: i18n.t('dashboard.text_127'),
          regionAccountType: 'region',
          usage_key: 'all.servers.memory',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 40,
          y: 6,
        },
        params: {
          name: i18n.t('dashboard.text_123'),
          regionAccountType: 'region',
          usage_key: 'all.servers.disk',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 60,
          y: 6,
        },
        params: {
          name: i18n.t('dashboard.text_158'),
          regionAccountType: 'region',
          usage_key: 'all.bucket_bytes',
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 0,
          y: 12,
        },
        params: {
          all_usage_key: 'hosts.cpu.virtual',
          all_usage_label: i18n.t('dashboard.virtual_total'),
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_135'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.un_allocated'),
          usage_key: 'all.servers.cpu',
          usage_label: i18n.t('dashboard.allocated'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 20,
          y: 12,
        },
        params: {
          all_usage_key: 'hosts.memory.virtual',
          all_usage_label: i18n.t('dashboard.virtual_total'),
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_132'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.un_allocated'),
          usage_key: 'all.servers.memory',
          usage_label: i18n.t('dashboard.allocated'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 40,
          y: 12,
        },
        params: {
          all_usage_key: 'storages.virtual',
          all_usage_label: i18n.t('dashboard.virtual_total'),
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_128'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.un_allocated'),
          usage_key: 'all.servers.disk',
          usage_label: i18n.t('dashboard.allocated'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 60,
          y: 12,
        },
        params: {
          all_usage_key: 'isolated_devices',
          all_usage_label: i18n.t('dashboard.virtual_total'),
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_129'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.un_allocated'),
          usage_key: 'all.servers.isolated_devices',
          usage_label: i18n.t('dashboard.allocated'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 0,
          y: 18,
        },
        params: {
          all_usage_key: 'all.eip.floating_ip',
          chart_type: 'liquidfill',
          color: 'reverse',
          name: i18n.t('dashboard.text_156'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.eip.floating_ip.used',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 20,
          y: 18,
        },
        params: {
          all_usage_key: 'all.ports',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_152'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'all.nics',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 40,
          y: 18,
        },
        params: {
          all_usage_key: 'all.servers',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_151'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.not_shutdown'),
          usage_key: 'all.ready_servers',
          usage_label: i18n.t('dashboard.shutdown'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 60,
          y: 18,
        },
        params: {
          all_usage_key: 'all.disks.count',
          chart_type: 'liquidfill',
          color: 'reverse',
          name: i18n.t('dashboard.text_147'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.not_mounted'),
          usage_key: 'all.disks.mounted.count',
          usage_label: i18n.t('dashboard.mounted'),
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 0,
          y: 24,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_126'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'usage_active,vm_cpu',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 20,
          y: 24,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_133'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'read_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 40,
          y: 24,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_125'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'write_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 60,
          y: 24,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.net.send.top5'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'bps_sent,vm_netio',
        },
      },
    ],
  },
  domain: {
    options: [
      { id: 'dashboard-domain-default', name: i18n.t('dashboard.text_121') },
    ],
    'dashboard-domain-default': [
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 0,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_130'),
          regionAccountType: 'region',
          usage_key: 'domain.servers',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 20,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_149'),
          regionAccountType: 'region',
          usage_key: 'domain.servers.cpu',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 40,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_157'),
          regionAccountType: 'region',
          usage_key: 'domain.servers.memory',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 60,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.memory_usage'),
          regionAccountType: 'region',
          usage_key: 'domain.disks',
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 0,
          y: 6,
        },
        params: {
          all_usage_key: 'domain.servers',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_151'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.not_shutdown'),
          usage_key: 'domain.ready_servers',
          usage_label: i18n.t('dashboard.shutdown'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 20,
          y: 6,
        },
        params: {
          all_usage_key: 'domain.disks.count',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.disks_unmounted'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.mounted'),
          usage_key: 'domain.disks.unmounted.count',
          usage_label: i18n.t('dashboard.not_mounted'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 40,
          y: 6,
        },
        params: {
          all_usage_key: 'domain.ports',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_152'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.un_allocated'),
          usage_key: 'domain.nics',
          usage_label: i18n.t('dashboard.allocated'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 60,
          y: 6,
        },
        params: {
          all_usage_key: 'domain.eip.floating_ip',
          chart_type: 'liquidfill',
          color: 'reverse',
          name: i18n.t('dashboard.text_156'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'domain.eip.floating_ip.used',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 0,
          y: 12,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_126'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'usage_active,vm_cpu',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 20,
          y: 12,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_133'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'read_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 40,
          y: 12,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_125'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'write_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'UserInfo',
          h: 8,
          w: 20,
          x: 60,
          y: 12,
        },
        params: {
          name: i18n.t('dashboard.userinfo'),
        },
      },
    ],
  },
  project: {
    options: [
      { id: 'dashboard-project-default', name: i18n.t('dashboard.text_121') },
    ],
    'dashboard-project-default': [
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 0,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_130'),
          regionAccountType: 'region',
          usage_key: 'servers',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 20,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_149'),
          regionAccountType: 'region',
          usage_key: 'servers.cpu',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 40,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.text_157'),
          regionAccountType: 'region',
          usage_key: 'servers.memory',
        },
      },
      {
        layout: {
          component: 'NumberCard',
          h: 6,
          w: 20,
          x: 60,
          y: 0,
        },
        params: {
          name: i18n.t('dashboard.memory_usage'),
          regionAccountType: 'region',
          usage_key: 'disks',
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 0,
          y: 6,
        },
        params: {
          all_usage_key: 'servers',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_151'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.not_shutdown'),
          usage_key: 'ready_servers',
          usage_label: i18n.t('dashboard.shutdown'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 20,
          y: 6,
        },
        params: {
          all_usage_key: 'disks.count',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.disks_unmounted'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.mounted'),
          usage_key: 'disks.unmounted.count',
          usage_label: i18n.t('dashboard.not_mounted'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 40,
          y: 6,
        },
        params: {
          all_usage_key: 'ports',
          chart_type: 'liquidfill',
          color: 'default',
          name: i18n.t('dashboard.text_152'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.un_allocated'),
          usage_key: 'nics',
          usage_label: i18n.t('dashboard.allocated'),
        },
      },
      {
        layout: {
          component: 'Ring',
          h: 6,
          w: 20,
          x: 60,
          y: 6,
        },
        params: {
          all_usage_key: 'eip.floating_ip',
          chart_type: 'liquidfill',
          color: 'reverse',
          name: i18n.t('dashboard.text_156'),
          regionAccountType: 'region',
          un_usage_label: i18n.t('dashboard.text_34'),
          usage_key: 'eip.floating_ip.used',
          usage_label: i18n.t('dashboard.text_33'),
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 0,
          y: 12,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_126'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'usage_active,vm_cpu',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 20,
          y: 12,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_133'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'read_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'Top5',
          h: 8,
          w: 20,
          x: 40,
          y: 12,
        },
        params: {
          brand: '',
          limit: 5,
          name: i18n.t('dashboard.text_125'),
          order: 'TOP',
          resType: 'server',
          time: 108000,
          usage: 'write_bps,vm_diskio',
        },
      },
      {
        layout: {
          component: 'UserInfo',
          h: 8,
          w: 20,
          x: 60,
          y: 12,
        },
        params: {
          name: i18n.t('dashboard.userinfo'),
        },
      },
    ],
  },
}
